<template>
  <v-container class="pa-0 dark" v-if="hasAnnouncements">
    <v-alert color="warning color-white--text"
             icon="fas fa-envelope"
             v-for="(announcement, i) in announcements"
             :key="i"
             class="mb-4 omaok-announcement"
             prominent
             dismissible>
      <template v-for="(content, j) in announcement.contents" v-if="content.locale === longLocale">
        <h7 class="color-white--text mt-2 text-h7" v-if="content.title !== '' && content.title !== null">
          {{ content.title }}
        </h7>
        <v-expand-transition>
          <p v-show="announcement.show || (content.title === '' || content.title === null)"
             :class="{ 'mb-0': content.title === '' || content.title === null }"
             v-html="content.text" />
        </v-expand-transition>
        <v-btn text
               small
               @click="announcement.show = !announcement.show"
               color="white"
               v-if="content.title !== '' && content.title !== null">
          <span v-if="!announcement.show">
            {{ $t('readMore') }}
          </span>
          <span v-if="announcement.show">
            {{ $t('close') }}
          </span>
          <v-icon right v-if="!announcement.show">fas fa-chevron-down</v-icon>
          <v-icon right v-if="announcement.show">fas fa-chevron-up</v-icon>
        </v-btn>
      </template>
    </v-alert>
  </v-container>
</template>

<script>
  import { mapGetters } from 'vuex'
  export default {
    computed: {
      ...mapGetters({
        longLocale: 'longLocale',
        announcements: 'announcements'
      }),
      hasAnnouncements () {
        if (this.announcements === null || this.announcements.length === 0) {
          return false
        } else {
          return true
        }
      }
    },
    created: function () {
      this.$store.dispatch('getAnnouncements')
    }
  }
</script>

<style>
  .omaok-announcement i, .omaok-announcement .v-alert__dismissible .v-icon {
    color: #fff;
  }
</style>
